var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 18.6797C1 16.4297 4 16.4297 5.5 14.9297C6.25 14.1797 4 14.1797 4 10.4297C4 7.92994 4.99975 6.67969 7 6.67969C9.00025 6.67969 10 7.92994 10 10.4297C10 14.1797 7.75 14.1797 8.5 14.9297C10 16.4297 13 16.4297 13 18.6797",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16.6797C12.567 16.2889 12.803 16.2507 13.5074 15.9115C14.058 15.6462 14.5893 15.3456 15.0053 14.9297C15.7553 14.1797 13.5053 14.1797 13.5053 10.4297C13.5053 7.92994 14.505 6.67969 16.5053 6.67969C18.5055 6.67969 19.5053 7.92994 19.5053 10.4297C19.5053 14.1797 17.2553 14.1797 18.0053 14.9297C19.5053 16.4297 22.5053 16.4297 22.5053 18.6797",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewDashboard);
export default __webpack_public_path__ + "static/media/viewDashboard.9c8a8ad422f0ee963ffcc48e06f15da4.svg";
export { ForwardRef as ReactComponent };